module.exports = __webpack_public_path__ + "img/HQ-PS24-V1.e4b0851d.jpg";